import React from "react";
import Lenovo from "./laptop-img/img1.png";
import Acer from "./laptop-img/img2.png";
import iMac from "./laptop-img/img3.jpg";
import HP from "./laptop-img/img4.png";
import Dell from "./laptop-img/img5.png";

const LaptopList = [
  { id: 1, productName: "Lenovo", img: Lenovo, price: "₹55000" },
  { id: 2, productName: "Acer", img: Acer, price: "₹38000" },
  { id: 3, productName: "iMac", img: iMac, price: "₹85000" },
  { id: 4, productName: "HP", img: HP, price: "₹48000" },
  { id: 5, productName: "Dell", img: Dell, price: "₹42000" },
];

export default LaptopList;
